import React from 'react';
import { Calendar, FileText, MessageCircle, CheckSquare, Repeat, ShieldCheck } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: Calendar,
    title: 'Tablero 30 días',
    desc: 'Un plan día por día diseñado para mujeres ocupadas. Sabrás exactamente qué hacer cada vez que tengas 45 minutos libres.'
  }, {
    icon: FileText,
    title: 'Plantillas de Micro-ofertas',
    desc: 'Diseña tu oferta en 60 minutos. Rellena los espacios y ten listo algo que la gente quiera comprar.'
  }, {
    icon: MessageCircle,
    title: 'Guiones de DM',
    desc: 'Textos exactos para conseguir conversaciones sin sentir vergüenza y sin sonar como un robot de ventas.'
  }, {
    icon: ShieldCheck,
    title: '3 Micro-tests',
    desc: 'Protocolos paso a paso para validar tus ideas sin gastar un solo dólar en publicidad.'
  }, {
    icon: CheckSquare,
    title: 'Checklist de Entrega',
    desc: 'Para que cumplas bien con tu cliente sin quemarte y asegurando que queden felices.'
  }, {
    icon: Repeat,
    title: 'Sistema Semanal',
    desc: 'Cómo repetir el proceso para crecer y conseguir ventas cada semana de forma predecible.'
  }];
  return <section className="py-20 bg-teal-900 text-white" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="text-center mb-16" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-101">
            Lo que incluye Side Hustle Express
          </h2>
          <p className="text-teal-200 text-lg max-w-2xl mx-auto" data-id="element-102">
            Un PDF práctico (sin relleno) con todo lo que necesitas para lanzar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-103">
          {items.map((item, index) => <div key={index} className="bg-teal-800/50 backdrop-blur-sm p-8 rounded-2xl border border-teal-700 hover:border-teal-500 transition-colors" data-id="element-104">
              <div className="flex items-start gap-4" data-id="element-105">
                <div className="bg-teal-500/20 p-3 rounded-lg" data-id="element-106">
                  <item.icon className="w-6 h-6 text-teal-300" data-id="element-107" />
                </div>
                <div data-id="element-108">
                  <h3 className="text-xl font-bold mb-2 text-white" data-id="element-109">
                    {item.title}
                  </h3>
                  <p className="text-teal-100/80 leading-relaxed" data-id="element-110">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}